import fileImg from '../../assets/icon/file.png';
import { GridContainer } from '../../styles/Global';
import { IndexContainer } from './Statistics.styled';

interface IProps {
  title: string;
  value: number;
  onClick?: () => void;
  isActive?: boolean;
}

const CardStats = ({ title, value, onClick, isActive }: IProps) => {
  return (
    <IndexContainer
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        backgroundColor: isActive ? '#f0f9ff' : 'transparent',
        borderBottom: isActive ? '3px solid #1570FF' : '3px solid transparent',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <img src={fileImg} alt="File Icon" />
      <GridContainer $col={1} $gap={4} $alignItems="start">
        <p className="title">{title}</p>
        <p className="value">{value}</p>
      </GridContainer>
    </IndexContainer>
  );
};
export default CardStats;
